export type MagicBentoVariant = "default" | "menu";

/** Gold torch glow — shared by Discover bento and player-menu variant. */
export const MAGIC_BENTO_DISCOVER_GLOW_RGB = "214, 153, 54";

/** Discover / marketing default particle load. */
export const MAGIC_BENTO_DEFAULT_PARTICLE_COUNT = 12;
/** Discover / marketing default spotlight radius (px). */
export const MAGIC_BENTO_DEFAULT_SPOTLIGHT_RADIUS = 300;

/**
 * Player-menu variant caps — lower torch particle + spotlight load on mobile drawers.
 * PlayerMenuGrid may still override via props.
 */
export const MAGIC_BENTO_MENU_PARTICLE_COUNT = 4;
export const MAGIC_BENTO_MENU_SPOTLIGHT_RADIUS = 160;

export function resolveMagicBentoPerfDefaults(
	variant: MagicBentoVariant = "default",
): { particleCount: number; spotlightRadius: number } {
	if (variant === "menu") {
		return {
			particleCount: MAGIC_BENTO_MENU_PARTICLE_COUNT,
			spotlightRadius: MAGIC_BENTO_MENU_SPOTLIGHT_RADIUS,
		};
	}
	return {
		particleCount: MAGIC_BENTO_DEFAULT_PARTICLE_COUNT,
		spotlightRadius: MAGIC_BENTO_DEFAULT_SPOTLIGHT_RADIUS,
	};
}

export function resolveMagicBentoParticleCount(
	variant: MagicBentoVariant,
	particleCount?: number,
): number {
	return (
		particleCount ?? resolveMagicBentoPerfDefaults(variant).particleCount
	);
}

export function resolveMagicBentoSpotlightRadius(
	variant: MagicBentoVariant,
	spotlightRadius?: number,
): number {
	return (
		spotlightRadius ??
		resolveMagicBentoPerfDefaults(variant).spotlightRadius
	);
}
